import { Component, OnInit } from '@angular/core';
import { SALADEPRENSA } from '../../interfaces/sala-de-prensa.interface';
import { SalaDePrensaService } from '../../services/sala-de-prensa.service';
import { salaDePrensaJson } from './sala-de-prensa.json';

@Component({
  selector: 'app-sala-de-prensa',
  templateUrl: './sala-de-prensa.component.html',
  styleUrls: ['./sala-de-prensa.component.css']
})
export class SalaDePrensaComponent implements OnInit {

  salaDePrensaData: any;
  salaDePrensaTitle: string = "sala de prensa";
  orderedsalaDePrensaData: any[] = [];

  constructor(
    private salaDePrensaService: SalaDePrensaService
  ) { }

  ngOnInit(): void {
    this.salaDePrensaService.getSalaDePrensaData().subscribe(
      (data) => {

        // Test if datePublishing is null or empty and in that case, test if date is less than today
        this.salaDePrensaData = data.data.articles.rows.filter(article => article.status === 1 && (!article.datePublishing || article.datePublishing === "" || new Date(article.datePublishing) < new Date()));

        // Sort by date
        this.orderedsalaDePrensaData = this.salaDePrensaData.sort((a, b) => new Date(b.date!).getTime() - new Date(a.date!).getTime());
      },
      (error) => { }
    )

  }

  sortPrensaBlockItems() {
    this.orderedsalaDePrensaData = this.salaDePrensaData.rows.sort((a, b) => new Date(b.date!).getTime() - new Date(a.date!).getTime());
  }

}
